import React from 'react'
import ProgramNutritionForm from './form'

export default function (props) {
  const data = { gender_segment: null, age_segment: null, bmi_segment: null, active: false }

  return (
    <ProgramNutritionForm data={data} {...props} />
  )
}